import { render } from "./SchemeAndNewsModalTable.vue?vue&type=template&id=afb736a0"
import script from "./SchemeAndNewsModalTable.vue?vue&type=script&lang=js"
export * from "./SchemeAndNewsModalTable.vue?vue&type=script&lang=js"

import "./SchemeAndNewsModalTable.vue?vue&type=style&index=0&id=afb736a0&lang=sass"

import exportComponent from "D:\\a\\1\\s\\Vind\\VindBack\\VindBackVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QBtn,QTable,QTr,QTd});qInstall(script, 'directives', {ClosePopup});
